var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperationOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0002 100.8C80.7426 100.8 100.8 80.7424 100.8 56C100.8 31.2576 80.7426 11.2 56.0002 11.2C31.2578 11.2 11.2002 31.2576 11.2002 56C11.2002 80.7424 31.2578 100.8 56.0002 100.8Z",
    fill: "#ECF2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7607 80.1215C37.7607 80.4714 37.8997 80.807 38.1472 81.0544C38.3946 81.3018 38.7302 81.4408 39.0801 81.4408H77.3505C77.7004 81.4408 78.036 81.3018 78.2834 81.0544C78.5309 80.807 78.6699 80.4714 78.6699 80.1215V37.2322L67.4531 26.0154H39.0801C38.9068 26.0152 38.7352 26.0492 38.575 26.1155C38.4149 26.1817 38.2694 26.2789 38.1468 26.4015C38.0243 26.524 37.9271 26.6695 37.8609 26.8297C37.7946 26.9898 37.7606 27.1614 37.7607 27.3347V80.1215Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7607 80.1215C37.7607 80.4714 37.8997 80.807 38.1472 81.0544C38.3946 81.3018 38.7302 81.4408 39.0801 81.4408H77.3505C77.7004 81.4408 78.036 81.3018 78.2834 81.0544C78.5309 80.807 78.6699 80.4714 78.6699 80.1215V37.2322L67.4531 26.0154H39.0801C38.9068 26.0152 38.7352 26.0492 38.575 26.1155C38.4149 26.1817 38.2694 26.2789 38.1468 26.4015C38.0243 26.524 37.9271 26.6695 37.8609 26.8297C37.7946 26.9898 37.7606 27.1614 37.7607 27.3347V80.1215Z",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6699 37.2322H68.6851C68.3584 37.2322 68.045 37.1024 67.814 36.8713C67.5829 36.6403 67.4531 36.3269 67.4531 36.0002V26.0154L78.6699 37.2322Z",
    fill: "#FFC341",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3928 93.8011C66.8774 93.8011 72.9448 92.9737 72.9448 91.9531C72.9448 90.9325 66.8774 90.1051 59.3928 90.1051C51.9083 90.1051 45.8408 90.9325 45.8408 91.9531C45.8408 92.9737 51.9083 93.8011 59.3928 93.8011Z",
    fill: "#D8E1E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7916 67.4991V72.427C71.7916 72.7538 71.6618 73.0672 71.4307 73.2982C71.1997 73.5292 70.8863 73.659 70.5596 73.659H63.1676C62.8408 73.659 62.5274 73.5292 62.2964 73.2982C62.0653 73.0672 61.9355 72.7538 61.9355 72.427V68.7311L64.264 67.1799C64.6684 66.9083 65.1445 66.7633 65.6315 66.7633C66.1186 66.7633 66.5947 66.9083 66.9991 67.1799L68.1572 67.9549C68.5129 68.1908 68.9246 68.3287 69.3507 68.3549C69.7768 68.381 70.2022 68.2945 70.5842 68.1039L71.7916 67.4991Z",
    fill: "white",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7783 41.627H71.7943",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6904 49.019H71.7944",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6904 56.411H71.7944",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6904 63.803H57.0104",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6904 71.195H57.0104",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5596 61.3391C70.8863 61.3391 71.1997 61.4689 71.4307 61.6999C71.6618 61.9309 71.7916 62.2443 71.7916 62.5711V67.499L70.5842 68.1038C70.2022 68.2945 69.7768 68.381 69.3507 68.3549C68.9246 68.3287 68.5129 68.1908 68.1572 67.9549L66.9991 67.1798C66.5947 66.9083 66.1186 66.7633 65.6315 66.7633C65.1445 66.7633 64.6684 66.9083 64.264 67.1798L61.9355 68.731V62.5711C61.9355 62.2443 62.0653 61.9309 62.2964 61.6999C62.5274 61.4689 62.8408 61.3391 63.1676 61.3391H70.5596Z",
    fill: "#FFC341",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationOverview);
export default __webpack_public_path__ + "static/media/operation-overview.7fe29165930ae5d848931823999fc37f.svg";
export { ForwardRef as ReactComponent };